export const ad_providers = ['monetag', 'gigapub', /*'onclicka'*/] as const;